<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <h3 class="page-header">Component Registration</h3>

    </div>
  </div>
  <div class="row">
    <div class="col-xs-12">
      <form novalidate #permGrid="ngForm" *ngIf="(components|async) != null">
        <div>
          <aims-common-table
            [dataSource]="componentsDataSource"
            [header]="componentsColumns"
            [permissions]="permissions"
            id="ComponentRegistration"
            (rowEdit)="handleRowEdit($event)"
            (rowDeleted)="handleRowDelete($event)"
            [stickyHeader]="true"
            [pageSize]="10"
          >
            <ng-template aimsCommonTableDynamicToolbar>
              <aims-common-button aria-label="Add" (click)="handleRowAdd()">
                <mat-icon>add</mat-icon>
                Add
              </aims-common-button>
            </ng-template>
            <!-- Component ID -->
            <aims-common-table-dynamic-row id="componentId">
              <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                {{element.componentId}}
              </ng-template>
            </aims-common-table-dynamic-row>

            <!-- Component Name -->
            <aims-common-table-dynamic-row id="component">
              <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                <div>
                  {{element.component}}
                </div>
              </ng-template>
            </aims-common-table-dynamic-row>

            <!-- Component Description -->
            <aims-common-table-dynamic-row id="description">
              <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                <quill-view [content]="dynamicControl?.value" >
                </quill-view>
              </ng-template>
            </aims-common-table-dynamic-row>

            <!--Parent-->
            <aims-common-table-dynamic-row id="parentComponentName">
              <ng-template viewMode let-element let-edittingRowElement="edittingRowElement" let-idx="idx" let-dynamicControl="dynamicControl">
                <div>
                    {{ element.parentComponentName }}
                </div>
              </ng-template>
            </aims-common-table-dynamic-row>
          </aims-common-table>
          </div>
        </form>
    </div>
  </div>

  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
